class Queue {
    constructor(key) {
        this.key=key;
        this._oldestIndex = 1;
        this._newestIndex = 1;
        this._storage = {};
        let storageDate = this._getStorage(key);
        if (storageDate) {
            for (let i in storageDate) {
                this._storage[this._newestIndex] = storageDate[i];
                this._newestIndex++;
            }
        }
    }

    _setStorage(key, value) {
        try {
            value = JSON.stringify(value);
            window.sessionStorage.setItem(key, value)
        } catch (e) {

        }
    }

    _getStorage(key) {

        try {
            let storageDate =  window.sessionStorage.getItem(key)
            return JSON.parse(storageDate);
        } catch (e) {

        }
    }

    size() {
        return this._newestIndex - this._oldestIndex;
    };

    enqueue(data) {
        this._storage[this._newestIndex] = data;
        this._newestIndex++;
        this._setStorage(this.key, this._storage)

    };

    dequeue() {
        var oldestIndex = this._oldestIndex,
            newestIndex = this._newestIndex,
            deletedData;

        if (oldestIndex !== newestIndex) {
            deletedData = this._storage[oldestIndex];
            delete this._storage[oldestIndex];
            this._oldestIndex++;
            this._setStorage(this.key, this._storage);
            return deletedData;
        }
    };
    getLast()
    {
        console.log("this._newestIndex", this._newestIndex);
        console.log("this._storage", this._storage);
        return this._storage[this._newestIndex -1] || null;
    }

}

module.exports = Queue;